export default "__VITE_ASSET__6a477312__"